import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgOftenDryGlyphSecondary from './svgs/OftenDryGlyphSecondary.js';
import SvgOftenDryGlyph from './svgs/OftenDryGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var oftenDryGlyph = (props => useIcon(SvgOftenDryGlyph, SvgOftenDryGlyphSecondary, props));

export { oftenDryGlyph as default };
